import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import history from '~/services/history';
import api from '~/services/api';

import { saveCrbFailure, saveCrbSuccess, updateCrbFailure, updateCrbSuccess } from './actions';

export function* saveCrb({ payload }) {
  try {
    yield call(api.post, 'api/crb', payload.data, { withCredentials: true });

    yield put(saveCrbSuccess());

    toast.success('CRB criado com sucesso!')

    history.push('/specifications/pilar3/resources/crb');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(saveCrbFailure());
  }
}

export function* updateCrb({ payload }) {
  try {
    const { id } = payload.data;
    yield call(api.post, `api/crb/${id}`, payload.data, { withCredentials: true });

    yield put(updateCrbSuccess());

    toast.success('CRB atualizado com sucesso!')

    history.push('/specifications/pilar3/resources/crb');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(updateCrbFailure());
  }
}

export default all([
  takeLatest('@crb/SAVE_REQUEST', saveCrb),
  takeLatest('@crb/UPDATE_REQUEST', updateCrb)
]);